


const customSearchInput = document.querySelector('.custom-search-input');
const clearBtn = document.querySelector('.search-drawer__clear');

// Hide initially
clearBtn.style.opacity = '0';
clearBtn.style.pointerEvents = 'none';

// On typing
customSearchInput.addEventListener('input', function () {
  if (this.value.trim().length > 0) {
    clearBtn.style.opacity = '1';
    clearBtn.style.pointerEvents = 'auto';
  } else {
    clearBtn.style.opacity = '0';
    clearBtn.style.pointerEvents = 'none';
  }
});

// Clear button click
clearBtn.addEventListener('click', function () {
  customSearchInput.value = '';
  clearBtn.style.opacity = '0';
  clearBtn.style.pointerEvents = 'none';
  customSearchInput.focus();
});



const customSearchInputssss = document.querySelector('.custom-search-input');
const showText = document.querySelector('.show_search_terms_here_new');

customSearchInputssss.addEventListener('input', function () {
  const value = this.value.trim();
  
  if (value.length > 0) {
    showText.textContent = `"${value}"`;
  } else {
    showText.textContent = '""';
  }
});




;(function () {
  /**
   * Store request ID for Boost Analytics tracking
   * @param {string} actionType - The action type (filter, search, suggest, recommend)
   * @param {string} rid - The request ID from API response
   */
  function storeRequestIdForAnalytics(actionType, rid) {
    if (!rid) return
    
    try {
      // Store in localStorage for analytics tracking
      var requestIdsKey = 'boostPFSRequestIds'
      var requestIds = {}
      
      var stored = localStorage.getItem(requestIdsKey)
      if (stored) {
        try {
          requestIds = JSON.parse(stored)
        } catch (e) {
          requestIds = {}
        }
      }
      
      requestIds[actionType] = {
        rid: rid,
        timestamp: Date.now()
      }
      
      localStorage.setItem(requestIdsKey, JSON.stringify(requestIds))
      
      // Also notify BoostAnalytics if available
      if (typeof window.BoostAnalytics !== 'undefined' && window.BoostAnalytics.setRequestId) {
        window.BoostAnalytics.setRequestId(actionType, rid)
      }
      
      console.log('[Custom Search] Stored request ID for analytics:', actionType, rid)
    } catch (e) {
      console.warn('[Custom Search] Failed to store request ID:', e)
    }
  }

  function debounce(fn, delay) {
    var timeoutId
    return function () {
      var context = this
      var args = arguments
      clearTimeout(timeoutId)
      timeoutId = setTimeout(function () {
        fn.apply(context, args)
      }, delay)
    }
  }

  function formatMoney(value) {
    var number = Number(value)
    if (!isFinite(number)) {
      return ""
    }
    return number.toFixed(2) + " USD" 
  }

  function setupInstance(input) {
    var root = input.closest("[data-search-custom-drawer]") || document
    var clearButton = root.querySelector(".search-drawer__clear")
    var resultsContainer = root.querySelector("[data-custom-search-results]")
    var toggleElements = root.querySelectorAll(".instant-search-container")
    var toggleElementsnew = root.querySelectorAll(".instant-search-drawer")
    var toggleElementsnew1 = root.querySelectorAll(".custom-search-drawer__panel")
    var productCountElements = root.querySelectorAll(".show_search_product_count_here, .show_search_product_count_here_new")
    var searchTermElements = root.querySelectorAll(".show_search_terms_here, .show_search_terms_here_new")
    var goToSearchLinks = root.querySelectorAll(".update_link_while_typing_and_go_to_search, .search_page_link")

    if (!resultsContainer) {
      var wrapper = root.querySelector(".Productsearch_custom") || root
      resultsContainer = document.createElement("div")
      resultsContainer.className = "boost-sear-result-with-api ProductList ProductList--grid Grid"
      resultsContainer.setAttribute("data-custom-search-results", "")
      wrapper.appendChild(resultsContainer)
    }

    var originalHtml = resultsContainer.innerHTML
    var currentRequestToken = 0

    function toggleActiveClass(hasProducts) {
      for (var i = 0; i < toggleElements.length; i++) {
        if (hasProducts) {
          toggleElements[i].classList.add("active")
          toggleElementsnew[i].classList.add("active")
          toggleElementsnew1[i].classList.add("active")
        } else {
          toggleElements[i].classList.remove("active")
          toggleElementsnew[i].classList.remove("active")
          toggleElementsnew1[i].classList.remove("active")
        }
      }
      
      // Show/hide filter toolbar based on search results (same as search page)
      var filterToolbar = root.querySelector('.instant-search-toolbar-layout')
      if (filterToolbar) {
        if (hasProducts) {
          filterToolbar.classList.add("active")
        } else {
          filterToolbar.classList.remove("active")
        }
      }
    }

    function updateSearchLink(term) {
      var sanitized = (term || "").trim()

      for (var i = 0; i < goToSearchLinks.length; i++) {
        var link = goToSearchLinks[i]
        if (!link) {
          continue
        }
        if (sanitized.length > 0) {
          link.href = "/search?q=" + encodeURIComponent(sanitized)
          link.classList.remove("is-disabled")
        } else {
          link.href = "/search?q="
          link.classList.add("is-disabled")
        }
      }
    }

    function updateSearchInfo(searchTerm, productCount) {
      if (productCountElements && productCountElements.length) {
        var paddedCount = String(productCount).padStart(2, '0')
        for (var i = 0; i < productCountElements.length; i++) {
          productCountElements[i].textContent = paddedCount
        }
      }
      if (searchTermElements && searchTermElements.length) {
        var formattedTerm = '"' + searchTerm + '"'
        for (var j = 0; j < searchTermElements.length; j++) {
          searchTermElements[j].textContent = formattedTerm
        }
      }
      updateSearchLink(searchTerm)
    }

    function clearSearchInfo() {
      if (productCountElements && productCountElements.length) {
        for (var i = 0; i < productCountElements.length; i++) {
          productCountElements[i].textContent = ""
        }
      }
      if (searchTermElements && searchTermElements.length) {
        for (var j = 0; j < searchTermElements.length; j++) {
          searchTermElements[j].textContent = '""'
        }
      }
      updateSearchLink("")
    }

    function showSkeletonLoader(container) {
      var skeletonCount = 0 // Show 6 skeleton cards for instant search
      var skeletonHTML = ""
      
      for (var i = 0; i < skeletonCount; i++) {
        skeletonHTML +=
          '<div class="Grid__Cell 1/2--phone 1/3--tablet-and-up 1/4--desk search-skeleton-item">' +
          '<div class="ProductItem">' +
          '<div class="ProductItem__Wrapper">' +
          '<div class="card-wrapper">' +
          '<div class="ProductItem__ImageWrapper">' +
          '<div class="AspectRatio AspectRatio--withFallback" style="padding-bottom: 150%; --aspect-ratio: 0.6666666666666666; position: relative;">' +
          '<div class="search-skeleton-image"></div>' +
          '</div>' +
          '</div>' +
          '<div class="available-variant-size custom-none">' +
          '<div class="search-skeleton-sizes"></div>' +
          '</div>' +
          '</div>' +
          '<div class="ProductItem__Info ProductItem__Info--center">' +
          '<div class="ProductItem__TitlePriceRow">' +
          '<h2 class="ProductItem__Title Heading">' +
          '<div class="search-skeleton-title"></div>' +
          '</h2>' +
          '<div class="ProductItem__PriceList Heading">' +
          '<div class="search-skeleton-price"></div>' +
          '</div>' +
          '</div>' +
          '<div class="ProductItem__ColorSwatchRow">' +
          '<div class="search-skeleton-swatches"></div>' +
          '</div>' +
          '</div>' +
          '</div>' +
          '</div>' +
          '</div>'
      }
      
      container.innerHTML = skeletonHTML
      
      // Inject skeleton styles if not already present
      injectSkeletonStyles()
    }

    function hideSkeletonLoader(container) {
      var skeletonItems = container.querySelectorAll(".search-skeleton-item")
      for (var i = 0; i < skeletonItems.length; i++) {
        skeletonItems[i].style.opacity = "0"
        skeletonItems[i].style.transition = "opacity 0.3s ease-out"
      }
      
      // Remove skeleton items after fade out
      setTimeout(function() {
        for (var j = 0; j < skeletonItems.length; j++) {
          skeletonItems[j].remove()
        }
      }, 300)
    }

    function injectSkeletonStyles() {
      // Check if styles are already injected
      if (document.getElementById("search-skeleton-styles")) {
        return
      }
      
      var style = document.createElement("style")
      style.id = "search-skeleton-styles"
      style.textContent =
        ".search-skeleton-item {" +
        "  animation: searchSkeletonFade 1.5s ease-in-out infinite;" +
        "}" +
        "@keyframes searchSkeletonFade {" +
        "  0%, 100% { opacity: 1; }" +
        "  50% { opacity: 0.6; }" +
        "}" +
        ".search-skeleton-image {" +
        "  position: absolute;" +
        "  top: 0;" +
        "  left: 0;" +
        "  width: 100%;" +
        "  height: 100%;" +
        "  min-height: 200px;" +
        "  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);" +
        "  background-size: 200% 100%;" +
        "  animation: searchSkeletonShimmer 1.5s infinite;" +
        "  border-radius: 0;" +
        "  z-index: 1;" +
        "}" +
        ".search-skeleton-item .AspectRatio {" +
        "  position: relative;" +
        "  min-height: 200px;" +
        "}" +
        ".search-skeleton-item .ProductItem__ImageWrapper {" +
        "  display: block;" +
        "}" +
        ".search-skeleton-sizes {" +
        "  height: 30px;" +
        "  margin: 10px 0;" +
        "  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);" +
        "  background-size: 200% 100%;" +
        "  animation: searchSkeletonShimmer 1.5s infinite;" +
        "  border-radius: 4px;" +
        "}" +
        ".search-skeleton-title {" +
        "  height: 20px;" +
        "  width: 70%;" +
        "  margin: 10px 0;" +
        "  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);" +
        "  background-size: 200% 100%;" +
        "  animation: searchSkeletonShimmer 1.5s infinite;" +
        "  border-radius: 4px;" +
        "}" +
        ".search-skeleton-price {" +
        "  height: 18px;" +
        "  width: 50%;" +
        "  margin: 5px 0;" +
        "  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);" +
        "  background-size: 200% 100%;" +
        "  animation: searchSkeletonShimmer 1.5s infinite;" +
        "  border-radius: 4px;" +
        "}" +
        ".search-skeleton-swatches {" +
        "  height: 25px;" +
        "  width: 60%;" +
        "  margin: 10px 0;" +
        "  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);" +
        "  background-size: 200% 100%;" +
        "  animation: searchSkeletonShimmer 1.5s infinite;" +
        "  border-radius: 4px;" +
        "}" +
        "@keyframes searchSkeletonShimmer {" +
        "  0% { background-position: 200% 0; }" +
        "  100% { background-position: -200% 0; }" +
        "}"
      
      document.head.appendChild(style)
    }

    function loadProductCards(handles) {
      var requests = handles.map(function(handle) {
        var productTileTemplateUrl = "/products/" + handle + "?view=search"
        return fetch(productTileTemplateUrl)
          .then(function(res) {
            if (res.status === 200) {
              return res.text()
            }
            return null
          })
          .catch(function(error) {
            console.error("Error loading product " + handle + ":", error)
            return null
          })
      })

      return Promise.all(requests).then(function(responses) {
        var validResponses = responses.filter(function(r) {
          return r !== null
        })
        // Wrap each product in Carousel__Cell div like the search page
        var wrappedHtml = validResponses.map(function(html) {
          return html
        })
        return wrappedHtml.join("")
      })
    }

    function renderResults(products, searchTerm, totalCount) {
      console.log('append search widget')
      if (!Array.isArray(products)) {
        resultsContainer.innerHTML = originalHtml
        toggleActiveClass(false)
        clearSearchInfo()
        return
      }

      // Filter out products with THFEEE tag and extract handles
      var productHandles = []
      for (var i = 0; i < products.length; i++) {
        var product = products[i]
        if (!product || !product.handle) {
          continue
        }
        var tags = Array.isArray(product.tags) ? product.tags : []
        var skip = tags.indexOf("THFEEE") !== -1
        if (!skip) {
          productHandles.push(product.handle)
        }
      }

      if (productHandles.length === 0) {
        hideSkeletonLoader(resultsContainer)
        resultsContainer.innerHTML = ""
        toggleActiveClass(false)
        clearSearchInfo()
        return
      }

      // Load product cards from template endpoint (skeleton already shown in fetchSuggestions)
      loadProductCards(productHandles).then(function(html) {
        if (!html || html.trim().length === 0) {
          hideSkeletonLoader(resultsContainer)
          resultsContainer.innerHTML = ""
          toggleActiveClass(false)
          clearSearchInfo()
        } else {
          // Hide skeleton first, then replace with products
          hideSkeletonLoader(resultsContainer)
          
          // Wait for skeleton fade out, then show products
          setTimeout(function() {
            resultsContainer.innerHTML = html
            toggleActiveClass(true)
            var displayCount = typeof totalCount === "number" ? totalCount : productHandles.length
            updateSearchInfo(searchTerm, displayCount)
            
            // Initialize product cards functionality (variants, swatches, add to cart, etc.)
            initializeProductCards(resultsContainer)
          }, 300) // Wait for skeleton fade out animation
        }
      }).catch(function(error) {
        console.error("Failed to load product cards:", error)
        hideSkeletonLoader(resultsContainer)
        resultsContainer.innerHTML = ""
        toggleActiveClass(false)
        clearSearchInfo()
      })
    }

    function initializeProductCards(container) {
      // Dispatch event to notify that search results have been loaded
      // This allows other scripts (like product-item-boost-cart.js) to re-initialize
      window.dispatchEvent(new CustomEvent("search-results-loaded", {
        detail: { container: container }
      }))
      
      // Re-initialize wishlist buttons if they exist
      var wishlistButtons = container.querySelectorAll("wishlist-item")
      if (wishlistButtons.length > 0) {
        // Wishlist custom element should handle its own initialization
        // But we trigger the event for any listeners
        for (var i = 0; i < wishlistButtons.length; i++) {
          wishlistButtons[i].dispatchEvent(new CustomEvent("initialize", { bubbles: true }))
        }
      }
      
      // Trigger lazy loading for images if needed
      if (typeof window.lazySizes !== "undefined") {
        window.lazySizes.init()
      }
      
      // Ensure show-size-search buttons are clickable
      var showSizeButtons = container.querySelectorAll(".show-size-search")
      for (var k = 0; k < showSizeButtons.length; k++) {
        showSizeButtons[k].style.pointerEvents = "auto"
        showSizeButtons[k].style.cursor = "pointer"
        showSizeButtons[k].style.zIndex = "10"
      }
      
      // Initialize image sliders for newly loaded products
      if (typeof window.initAllImageSliders === 'function') {
        setTimeout(function() {
          window.initAllImageSliders()
        }, 100)
      }
      
      // Re-initialize any product-related scripts
      if (typeof window.theme !== "undefined" && window.theme.ProductVariants) {
        var productItems = container.querySelectorAll(".ProductItem")
        for (var j = 0; j < productItems.length; j++) {
          // Product variants should be handled by event delegation in product-item-boost-cart.js
          // But we can trigger initialization if needed
        }
      }
    }

    function renderSuggestions(suggestions) {
      var suggestionsContainer = root.querySelector(".search_suggetions_block")
      var suggestionsSection = root.querySelector(".search_suggetions")
      var hideElement = root.querySelector(".hide_this_if_suggestions_showing")

      if (!suggestionsContainer) {
        return
      }

      if (suggestions && Array.isArray(suggestions) && suggestions.length > 0) {
        var suggestionsHtml = ""
        for (var i = 0; i < suggestions.length; i++) {
          var suggestion = suggestions[i]
          var suggestionUrl = "/search?q=" + encodeURIComponent(suggestion)
          suggestionsHtml +=
            '<div class="popular_search_words_inner search_suggetions_block_iiner">' +
            '<a href="' + suggestionUrl + '" class="popular_search_words_inner_button search_suggetions_block_apped">' +
            suggestion +
            "</a>" +
            "</div>"
        }
        suggestionsContainer.innerHTML = suggestionsHtml
        if (suggestionsSection) {
          suggestionsSection.style.display = "block"
        }

        if (hideElement) {
          hideElement.style.display = "none"
        }
      } else {
        if (suggestionsSection) {
          suggestionsSection.style.display = "none"
        }

        if (hideElement) {
          hideElement.style.display = "block"
        }
      }
    }

    function fetchAllProducts(query) {
      var searchBaseUrl =
        "https://services.mybcapps.com/bc-sf-filter/search?q=" +
        encodeURIComponent(query) +
        "&shop=elie-tahari.myshopify.com"
      var page = 1
      var aggregatedProducts = []
      var totalProducts = null
      var MAX_PAGES = 40

      function loadNextPage() {
        var pageUrl = searchBaseUrl + "&page=" + page

        return fetch(pageUrl, { method: "GET" })
          .then(function (response) {
            if (!response.ok) {
              throw new Error("Search request was not ok")
            }
            return response.json()
          })
          .then(function (data) {
            // Capture request ID (rid) for analytics tracking (only on first page)
            if (page === 1) {
              if (data && data.meta && data.meta.rid) {
                storeRequestIdForAnalytics('search', data.meta.rid)
              } else if (data && data.rid) {
                storeRequestIdForAnalytics('search', data.rid)
              }
            }

            if (typeof totalProducts !== "number") {
              totalProducts = typeof data.total_product === "number" ? data.total_product : 0
            }

            var pageProducts = Array.isArray(data.products) ? data.products : []
            if (pageProducts.length) {
              aggregatedProducts = aggregatedProducts.concat(pageProducts)
            }

            var shouldLoadMore =
              aggregatedProducts.length < (totalProducts || 0) &&
              pageProducts.length > 0 &&
              page < MAX_PAGES

            if (shouldLoadMore) {
              page += 1
              return loadNextPage()
            }

            return {
              products: aggregatedProducts,
              total: totalProducts || aggregatedProducts.length
            }
          })
      }

      return loadNextPage()
    }

    function fetchSuggestions(query) {
      var requestToken = ++currentRequestToken
    //   console.log('data' , data)

      if (!query || query.length < 1) {
        resultsContainer.innerHTML = originalHtml 
        toggleActiveClass(false)
        clearSearchInfo()
        renderSuggestions([])
        return
      }

      // Dispatch event for instant search filter to know the search term changed
      document.dispatchEvent(new CustomEvent('instant-search-term-changed', {
        detail: { searchTerm: query }
      }))

      // Show skeleton loader when search starts
      showSkeletonLoader(resultsContainer)

      var url =
        "https://services.mybcapps.com/bc-sf-filter/search/suggest?q=" +
        encodeURIComponent(query) +
        "&shop=elie-tahari.myshopify.com"

      fetch(url, { method: "GET" })
        .then(function (response) {
          if (!response.ok) {
            throw new Error("Network response was not ok")
          }
          return response.json()
        })
        .then(function (data) {
          if (requestToken !== currentRequestToken) {
            return
          }

          // Capture request ID (rid) for analytics tracking
          if (data && data.meta && data.meta.rid) {
            storeRequestIdForAnalytics('suggest', data.meta.rid)
          } else if (data && data.rid) {
            storeRequestIdForAnalytics('suggest', data.rid)
          }

          if (data && Array.isArray(data.products)) {
            var totalFromSuggest = typeof data.total_product === "number" ? data.total_product : undefined
            renderResults(data.products, query, totalFromSuggest)
            console.log('data' , data.products)
            console.log('data' , data.total_product)
            

            if (data.all_empty === true) {
                document.querySelector('.no_result_found').classList.add('active');
            } else {
                document.querySelector('.no_result_found').classList.remove('active');
            }

            document.querySelector('.search-drawer__clear.icon-button')
                .addEventListener('click', function () {
                    document.querySelector('.no_result_found')
                        .classList.remove('active');
                });
                console.log("suggestions eeee:", data.suggestions)
            if (data.suggestions && Array.isArray(data.suggestions)) {
              console.log("suggestions:", data.suggestions)
              renderSuggestions(data.suggestions)
            } else {
              renderSuggestions([])
            }

            fetchAllProducts(query)
              .then(function (fullResult) {
                if (requestToken !== currentRequestToken) {
                  return
                }
                if (fullResult && Array.isArray(fullResult.products)) {
                  renderResults(fullResult.products, query, fullResult.total)
                }
              })
              .catch(function (error) {
                if (requestToken !== currentRequestToken) {
                  return
                }
                console.error("Failed to load full search results", error)
              })

    
          } else {
            hideSkeletonLoader(resultsContainer)
            resultsContainer.innerHTML = originalHtml
            toggleActiveClass(false)
            clearSearchInfo()
            renderSuggestions([])
          }
        })
        .catch(function (error) {
          if (requestToken !== currentRequestToken) {
            return
          }
          console.error("Suggestion request failed", error)
          hideSkeletonLoader(resultsContainer)
          resultsContainer.innerHTML = originalHtml
          toggleActiveClass(false)
          clearSearchInfo()
          renderSuggestions([])
        })
        
    }

    updateSearchLink(input.value || "")

    var debouncedFetch = debounce(function (value) {
      fetchSuggestions(value.trim())
    }, 300)

    input.addEventListener("input", function (event) {
      var value = event.target.value || ""
      updateSearchLink(value)
      debouncedFetch(value)
    })

    if (clearButton) {
      clearButton.addEventListener("click", function () {
        input.value = ""
        resultsContainer.innerHTML = originalHtml
        toggleActiveClass(false)
        clearSearchInfo()
        renderSuggestions([])
      })
    }
  }

  function initCustomSearchBoost() {
    var inputs = document.querySelectorAll(".custom-search-input")
    if (!inputs.length) {
      return
    }

    for (var i = 0; i < inputs.length; i++) {
      setupInstance(inputs[i])
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initCustomSearchBoost)
  } else {
    initCustomSearchBoost()
  }

  // ========================================
  // OLD Instant Search Filter Drawer Functionality - REMOVED
  // Now handled by instant-search-filter-bs.js with custom classes
  // ========================================

  // ========================================
  // Listen for filter applied events from instant-search-filter-bs.js
  // ========================================
  document.addEventListener('instant-search-filter-applied', function(e) {
    if (!e.detail) return;
    
    var searchTerm = e.detail.searchTerm;
    var filterParams = e.detail.filterParams || '';
    var sort = e.detail.sort || 'relevance';
    
    if (!searchTerm) return;
    
    console.log('[Custom Search Boost] Filter applied event received:', e.detail);
    
    // Fetch filtered results
    fetchFilteredSearchResults(searchTerm, filterParams, sort);
  });

  /**
   * Fetch search results with filters applied (no URL modification)
   */
  function fetchFilteredSearchResults(searchTerm, filterParams, sort) {
    var root = document.querySelector("[data-search-custom-drawer]") || document;
    var resultsContainer = root.querySelector("[data-custom-search-results]");
    var productCountElements = root.querySelectorAll(".show_search_product_count_here, .show_search_product_count_here_new");
    var searchTermElements = root.querySelectorAll(".show_search_terms_here, .show_search_terms_here_new");
    var toggleElements = root.querySelectorAll(".instant-search-container");
    var toggleElementsnew = root.querySelectorAll(".instant-search-drawer");
    var toggleElementsnew1 = root.querySelectorAll(".custom-search-drawer__panel");
    
    if (!resultsContainer) return;
    
    // Show skeleton loader
    showFilteredSearchSkeletonLoader(resultsContainer);
    
    // Build the API URL with filters (do NOT modify browser URL)
    var timestamp = Date.now();
    var baseUrl = 'https://services.mybcapps.com/bc-sf-filter/search';
    var url = baseUrl + '?t=' + timestamp +
              '&q=' + encodeURIComponent(searchTerm) +
              '&shop=elie-tahari.myshopify.com' +
              '&limit=24' +
              '&sort=' + (sort || 'relevance') +
              '&build_filter_tree=true' +
              '&product_available=true' +
              '&variant_available=true';
    
    if (filterParams) {
      url += '&' + filterParams;
    }
    
    console.log('[Custom Search Boost] Fetching filtered results from:', url);
    
    fetch(url, { method: 'GET' })
      .then(function(response) {
        if (!response.ok) throw new Error('Filter search request failed');
        return response.json();
      })
      .then(function(data) {
        // Capture request ID (rid) for analytics tracking
        if (data && data.meta && data.meta.rid) {
          storeRequestIdForAnalytics('search', data.meta.rid);
        } else if (data && data.rid) {
          storeRequestIdForAnalytics('search', data.rid);
        }

        if (data && Array.isArray(data.products)) {
          var totalCount = data.total_product || data.products.length;
          
          // Update count display
          if (productCountElements && productCountElements.length) {
            var paddedCount = String(totalCount).padStart(2, '0');
            for (var i = 0; i < productCountElements.length; i++) {
              productCountElements[i].textContent = paddedCount;
            }
          }
          
          // Update search term display
          if (searchTermElements && searchTermElements.length) {
            var formattedTerm = '"' + searchTerm + '"';
            for (var j = 0; j < searchTermElements.length; j++) {
              searchTermElements[j].textContent = formattedTerm;
            }
          }
          
          // Load product cards
          loadFilteredProductCards(resultsContainer, data.products, toggleElements, toggleElementsnew, toggleElementsnew1);
        } else {
          hideFilteredSearchSkeletonLoader(resultsContainer);
          resultsContainer.innerHTML = '';
          toggleFilteredActiveClass(toggleElements, toggleElementsnew, toggleElementsnew1, false);
        }
      })
      .catch(function(error) {
        console.error('[Custom Search Boost] Filter search error:', error);
        hideFilteredSearchSkeletonLoader(resultsContainer);
        resultsContainer.innerHTML = '';
        toggleFilteredActiveClass(toggleElements, toggleElementsnew, toggleElementsnew1, false);
      });
  }

  /**
   * Load product cards for filtered results
   */
  function loadFilteredProductCards(container, products, toggleElements, toggleElementsnew, toggleElementsnew1) {
    if (!products || products.length === 0) {
      hideFilteredSearchSkeletonLoader(container);
      container.innerHTML = '';
      toggleFilteredActiveClass(toggleElements, toggleElementsnew, toggleElementsnew1, false);
      return;
    }
    
    var handles = products.map(function(p) { return p.handle; }).filter(Boolean);
    
    var requests = handles.map(function(handle) {
      var productTileTemplateUrl = "/products/" + handle + "?view=search";
      return fetch(productTileTemplateUrl)
        .then(function(res) {
          if (res.status === 200) return res.text();
          return null;
        })
        .catch(function(error) {
          console.error("Error loading product " + handle + ":", error);
          return null;
        });
    });
    
    Promise.all(requests).then(function(responses) {
      var validResponses = responses.filter(function(r) { return r !== null; });
      
      hideFilteredSearchSkeletonLoader(container);
      
      if (validResponses.length === 0) {
        container.innerHTML = '';
        toggleFilteredActiveClass(toggleElements, toggleElementsnew, toggleElementsnew1, false);
        return;
      }
      
      container.innerHTML = validResponses.join("");
      toggleFilteredActiveClass(toggleElements, toggleElementsnew, toggleElementsnew1, true);
      
      // Re-initialize product cards
      window.dispatchEvent(new CustomEvent("search-results-loaded", {
        detail: { container: container }
      }));
      
      // Initialize image sliders
      if (typeof window.initAllImageSliders === 'function') {
        setTimeout(window.initAllImageSliders, 100);
      }
    });
  }

  /**
   * Show skeleton loader for filtered search
   */
  function showFilteredSearchSkeletonLoader(container) {
    var skeletonCount = 6;
    var skeletonHTML = "";
    
    for (var i = 0; i < skeletonCount; i++) {
      skeletonHTML +=
        '<div class="Grid__Cell 1/2--phone 1/3--tablet-and-up 1/4--desk search-skeleton-item">' +
        '<div class="ProductItem">' +
        '<div class="ProductItem__Wrapper">' +
        '<div class="card-wrapper">' +
        '<div class="ProductItem__ImageWrapper">' +
        '<div class="AspectRatio AspectRatio--withFallback" style="padding-bottom: 150%; --aspect-ratio: 0.6666666666666666; position: relative;">' +
        '<div class="search-skeleton-image"></div>' +
        '</div></div></div>' +
        '<div class="ProductItem__Info ProductItem__Info--center">' +
        '<div class="ProductItem__TitlePriceRow">' +
        '<h2 class="ProductItem__Title Heading"><div class="search-skeleton-title"></div></h2>' +
        '<div class="ProductItem__PriceList Heading"><div class="search-skeleton-price"></div></div>' +
        '</div></div></div></div></div>';
    }
    
    container.innerHTML = skeletonHTML;
  }

  /**
   * Hide skeleton loader for filtered search
   */
  function hideFilteredSearchSkeletonLoader(container) {
    var skeletonItems = container.querySelectorAll(".search-skeleton-item");
    for (var i = 0; i < skeletonItems.length; i++) {
      skeletonItems[i].style.opacity = "0";
      skeletonItems[i].style.transition = "opacity 0.3s ease-out";
    }
    
    setTimeout(function() {
      for (var j = 0; j < skeletonItems.length; j++) {
        skeletonItems[j].remove();
      }
    }, 300);
  }

  /**
   * Toggle active class for filtered results
   */
  function toggleFilteredActiveClass(toggleElements, toggleElementsnew, toggleElementsnew1, hasProducts) {
    for (var i = 0; i < toggleElements.length; i++) {
      if (hasProducts) {
        toggleElements[i].classList.add("active");
        if (toggleElementsnew[i]) toggleElementsnew[i].classList.add("active");
        if (toggleElementsnew1[i]) toggleElementsnew1[i].classList.add("active");
      } else {
        toggleElements[i].classList.remove("active");
        if (toggleElementsnew[i]) toggleElementsnew[i].classList.remove("active");
        if (toggleElementsnew1[i]) toggleElementsnew1[i].classList.remove("active");
      }
    }
  }
})()